import { createContext, useContext } from 'react';

export type ActionBarLabelsFrom = 'narrow' | 'wide';

interface ActionBarResponsiveClasses {
    label: string;
    shortLabel: string;
    closeIcon: string;
    trailingPadding: string;
    hoverShift: string;
    shellPadding: string;
    dividerMargin: string;
}

const RESPONSIVE_CLASSES: Record<
    ActionBarLabelsFrom,
    ActionBarResponsiveClasses
> = {
    narrow: {
        label: 'hidden @narrow:inline',
        shortLabel: '@narrow:hidden',
        closeIcon: 'hidden @narrow:block',
        trailingPadding: 'pr-3 @narrow:pr-5',
        hoverShift:
            '@narrow:group-hover:-translate-x-2.5 @narrow:group-focus-within:-translate-x-2.5',
        shellPadding: 'pl-3 @narrow:pl-5',
        dividerMargin: 'mr-2 @narrow:mr-5',
    },
    wide: {
        label: 'hidden @wide:inline',
        shortLabel: '@wide:hidden',
        closeIcon: 'hidden @wide:block',
        trailingPadding: 'pr-3 @wide:pr-5',
        hoverShift:
            '@wide:group-hover:-translate-x-2.5 @wide:group-focus-within:-translate-x-2.5',
        shellPadding: 'pl-3 @wide:pl-5',
        dividerMargin: 'mr-2 @wide:mr-5',
    },
};

export const ActionBarLabelsContext =
    createContext<ActionBarLabelsFrom>('narrow');

export function useActionBarResponsiveClasses(): ActionBarResponsiveClasses {
    return RESPONSIVE_CLASSES[useContext(ActionBarLabelsContext)];
}
